__turbopack_context__.v({
  "popover": "Popover-module__459JYa__popover",
  "popoverContent": "Popover-module__459JYa__popoverContent",
  "popoverContentOpen": "Popover-module__459JYa__popoverContentOpen",
  "popoverContentPortaled": "Popover-module__459JYa__popoverContentPortaled",
});
